import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

export function getArcBaseUrl() {
  //return "http://localhost:50290";
  return environment.xenithApiEndpoint;
}

export function getArcWebUrl(parameters) {
  return environment.xenithWeb;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'ARC_API_URL', useFactory: getArcBaseUrl, deps: [] },
  { provide: 'ARC_WEB_URL', useFactory: getArcWebUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
